import { ref } from 'vue';
import categoryService from '@/services/categoryService';
import userService from '@/services/userServices';
import { useUserStore } from '@/stores/userStore';
import { useCartStore } from '@/stores/cart';
// import eventBus from '@/utils/eventBus';

export function useUsers(axios) {
  const categories = ref([]);
  const subcategory = ref();
  const brands = ref([]);
  const loading = ref(true);
  const error = ref(null);
  
  // const user_id=ref('');
  // const mcano=ref('');
  // const name=ref('');
  // const accessToken=ref('');
  // const refreshToken=ref('');

  const category = ref([]);

  const userLogin = async (username,password)=>{
    const userStore = useUserStore();
    const loading = ref(true);
    const error = ref(null);
    
    try {
      const data = await userService.loginUser({ mca_no:username, password });
      const { accessToken, refreshToken } = data;
      const data2 = await userService.getUserDetails(accessToken );
      console.log(data2);
      const profileData=data2;
      userStore.setProfileData(profileData);
      // alert('set prpfile data');
      // console.log(userStore.getProfileData,'here');
      userStore.setmcano(profileData.profile.mca_no); 
      const type = profileData.profile.type;
      userStore.setType(type);
      const fssai = profileData.profile.fssai;
      userStore.setfssai(fssai);
      const pan = profileData.profile.pan_no;
      userStore.setPan(pan);
      const name = profileData.profile.first_name+' '+profileData.profile.last_name;
      userStore.setuserName(name);
      // alert(profileData.profile.kyc_no)
      const kycDone = (profileData.profile.kyc_no==null ||profileData.profile?.kyc_no=='')?false:true;
      userStore.setKycAvailable(kycDone);
      // alert(accessToken, refreshToken)
      await userStore.setUserDetails(accessToken, refreshToken );
      userStore.setShippingAddress(null);
      userStore.setCartId(null);
      console.log(userStore.shippingAddress);
      const cartItems = JSON.parse(JSON.stringify(useCartStore().items));
      const hasLocalCart = cartItems.some(item => item.isLocalCart === true);
      setTimeout(()=>{
        if(!userStore.shippingAddress && hasLocalCart){
          // if(eventBus.panelOpen){
          //     eventBus.panelOpen("Select Address")
          //   }
        }else{
          const cartStore = useCartStore();
          cartStore.updateCartActions(username.value,true);
        }
        // if(eventBus.panelOpen && (profileData.profile?.kyc_no==''||profileData.profile?.kyc_no==null) && profileData.profile?.type==1){
        //   // alert('opened pc to consultatn')
        //     eventBus.panelOpen("KYC Update")
        //   }
        //to get local cart to dynamic cart
        // const cartStore = useCartStore();
        // cartStore.updateCartActions(username.value,true);
      },1000)
      // useCartStore().fetchCart();
      return data;
      // console.log()
    } catch (err) {
      console.log(err);
      error.value = 'Failed to login';
    } finally {
      loading.value = false;
    }
  }
  const userCmsLogin = async (username,password)=>{
    const userStore = useUserStore();
    const loading = ref(true);
    const error = ref(null);
    
    try {
      const data = await userService.loginCmsUser({ username, password });
      const { accessToken, refreshToken } = data;
      console.log(accessToken,refreshToken);
      userStore.setuserType('admin');
      userStore.setAdminAccessToken(accessToken);
      userStore.setAdminRefreshToken(refreshToken);
      // const data2 = await userService.getUserDetails(accessToken );
      // console.log(data2);
      // const profileData=data2;
      // userStore.setProfileData(profileData);
      // alert('set prpfile data');
      // console.log(userStore.getProfileData,'here');
      // userStore.setmcano(profileData.profile.mca_no); 
      // const type = profileData.profile.type;
      // userStore.setType(type);
      // const fssai = profileData.profile.fssai;
      // userStore.setfssai(fssai);
      // const pan = profileData.profile.pan_no;
      // userStore.setPan(pan);
      // const name = profileData.profile.first_name+' '+profileData.profile.last_name;
      // userStore.setuserName(name);
      // alert(profileData.profile.kyc_no)
      // const kycDone = (profileData.profile.kyc_no==null ||profileData.profile?.kyc_no=='')?false:true;
      // userStore.setKycAvailable(kycDone);
      // alert(accessToken, refreshToken)
      // await userStore.setUserDetails(accessToken, refreshToken );
      // userStore.setShippingAddress(null);
      // userStore.setCartId(null);
      // console.log(userStore.shippingAddress);
      // const cartItems = JSON.parse(JSON.stringify(useCartStore().items));
      // const hasLocalCart = cartItems.some(item => item.isLocalCart === true);
      // setTimeout(()=>{
      //   if(!userStore.shippingAddress && hasLocalCart){
          // if(eventBus.panelOpen){
          //     eventBus.panelOpen("Select Address")
          //   }
        // }else{
        //   const cartStore = useCartStore();
        //   cartStore.updateCartActions(username.value,true);
        // }
        // if(eventBus.panelOpen && (profileData.profile?.kyc_no==''||profileData.profile?.kyc_no==null) && profileData.profile?.type==1){
        //   // alert('opened pc to consultatn')
        //     eventBus.panelOpen("KYC Update")
        //   }
        //to get local cart to dynamic cart
        // const cartStore = useCartStore();
        // cartStore.updateCartActions(username.value,true);
      // },1000)
      // useCartStore().fetchCart();
      return data;
      // console.log()
    } catch (err) {
      console.log(err);
      error.value = 'Failed to login';
    } finally {
      loading.value = false;
    }
  }
  const createUser = async (formData)=>{
    // const userStore = useUserStore();
    const loading = ref(true);
    const error = ref(null);
    
    try {
      const data = await userService.createUser(formData);
      // const { accessToken, refreshToken } = data;
      // userStore.setUserDetails({ accessToken, refreshToken });
      // console.log(data);
      return data;
      // console.log()
    } catch (err) {
      error.value = 'Failed to Create';
    } finally {
      loading.value = false;
    }
  }
  const userCmsLogout = async ()=>{
    const userStore = useUserStore();
    const loading = ref(true);
    const error = ref(null);
    
    try {
      const refreshToken = userStore.getAdminRefreshToken;
      const data = await userService.logoutCmsUser( refreshToken );
      // const { accessToken, refreshToken } = data;
      // userStore.setUserDetails( accessToken, refreshToken );
			window.location.href='/';
      console.log(data);
      return data;
      // console.log()
    } catch (err) {
      error.value = 'Failed to login';
    } finally {
      loading.value = false;
    }
  }
  const userLogout = async ()=>{
    const userStore = useUserStore();
    const loading = ref(true);
    const error = ref(null);
    
    try {
      const refreshToken = userStore.getRefreshToken;
      const accessToken = userStore.getAccessToken;
      const data = await userService.logoutUser( refreshToken );
      // const { accessToken, refreshToken } = data;
      userStore.setUserDetails( accessToken, refreshToken );
			window.location.href='/';
      console.log(data);
      return data;
      // console.log()
    } catch (err) {
      error.value = 'Failed to login';
    } finally {
      loading.value = false;
    }
  }
  const fetchCategories = async (page = '') => {
    try {
      const { data } = await categoryService(axios).getCategories(page);
      console.log(data)
      categories.value = data;
    } catch (err) {
      error.value = 'Failed to load Categories';
    } finally {
      loading.value = false;
    }
  };
  const fetchCategoryBySlug = async (slug) => {
    try {
      const {data} = await categoryService(axios).getCategoryBySlug(slug);
      // console.log(data)
      category.value = data;
    } catch (err) {
      error.value = 'Failed to load Category';
    } finally {
      loading.value = false;
    }
  };
  const fetchSubcategories = async (slug) => {
    try {
      const { data } = await categoryService(axios).getSubcategories(slug);
      // console.log(data)
      categories.value = data.subcategories;
    } catch (err) {
      error.value = 'Failed to load Subcategory';
    } finally {
      loading.value = false;
    }
  };
  const fetchBrands = async () => {
    try {
      const { data } = await categoryService(axios).getBrands();
      // console.log(data)
      brands.value = data;
    } catch (err) {
      error.value = 'Failed to load Brands';
    } finally {
      loading.value = false;
    }
  };

  const updatePanDetails = async (panNo, panVerified) => {
    const userStore = useUserStore();

    if (!panVerified) {
      // If PAN is not verified, return this message early
      return 'PAN not Verified';
    }

    try {
      const response = await userService.updatePanDetails(panNo, userStore.getAccessToken);
      console.log('PAN details updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating PAN details:', error);
      throw error;
    }
  };
  const updateContact = async (mobileno, mobileVerified) => {
    const userStore = useUserStore();

    if (!mobileVerified) {
      // If PAN is not verified, return this message early
      return 'Mobile not Verified';
    }

    try {
      const response = await userService.updateContact(mobileno, userStore.getAccessToken);
      console.log('Contact details updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating COntact details:', error);
      throw error;
    }
  };
  const updateEmail = async (email, emailVerified) => {
    const userStore = useUserStore();

    if (!emailVerified) {
      // If PAN is not verified, return this message early
      return 'Mobile not Verified';
    }

    try {
      const response = await userService.updateEmail(email, userStore.getAccessToken);
      console.log('Email details updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating Email details:', error);
      throw error;
    }
  };
  const updateNeft = async (confirm_account_number, account_holder_name, ifsc_code, bank_name) => {

    try {
      const response = await userService.updateNEFTDetails(confirm_account_number, account_holder_name, ifsc_code, bank_name);
      console.log('NEFT details updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating NEFT details:', error);
      throw error;
    }
  };
  const pcToconsultant = async (mca_no, aadharId) => {

    try {
      const response = await userService.pcToconsultant(mca_no, aadharId);
      console.log('pcToconsultant updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating pcToconsultant:', error);
      throw error;
    }
  };
  const fetchShippingPincode = async (searchValue) => {

    try {
      const response = await userService.searchShippingPincode(searchValue);
      console.log('shippingcode:', response);
      return response;
    } catch (error) {
      console.error('Error searching shippingcode:', error);
      throw error;
    }
  };

   


  return {
    category,
    categories,
    brands,
    loading,
    error,
    subcategory,
    userLogout,
    userLogin,
    fetchBrands,
    fetchCategories,
    fetchCategoryBySlug,
    fetchSubcategories,
    createUser,
    updatePanDetails,
    updateContact,
    updateEmail,
    updateNeft,
    pcToconsultant,
    fetchShippingPincode,
    userCmsLogin,
    userCmsLogout
  };
}